
import {Component, Vue} from "vue-property-decorator";
import PersonelTurleriList from "@/components/lists/PersonelTurleriList.vue";
import PersonelTurleriMatrisList from "@/components/lists/PersonelTurleriMatrisList.vue";
import KisilerRolAtama from "@/components/lists/KisilerRolAtama.vue";
import SayfaAciklama from "@/components/SayfaAciklama.vue";
import {yeniYetkiModu} from "@/plugins/yetkiKontrol";
import YetkiGecisiDugmesi from "@/components/yetki-gecisi/YetkiGecisiDugmesi.vue";

@Component({
  components: {SayfaAciklama, PersonelTurleriList, PersonelTurleriMatrisList, KisilerRolAtama, YetkiGecisiDugmesi},
})
export default class OfisTercihlerView extends Vue {
  tab = 0;
  // "Kişiler & Rol Ataması" sekmesindeki sayaç rozeti (KisilerRolAtama yükleyince bildirir).
  kisiSayisi = 0;

  // Yeni yetki modu yalnız sunucu işareti "yeni" ise açılır; aksi hâlde (eski / bayat oturum)
  // ESKİ mod. K1 güvenli varsayılan. Tespit tek kaynakta (yetkiKontrol.yeniYetkiModu).
  get yeniMod(): boolean {
    return yeniYetkiModu(this.$store.state.user);
  }

  // Kısıtlı dönemde yalnız rol yönetimi (ekle, ad, sil, rol atama) kapanır; matris ve kişiye özel
  // yetki uçları API'de lisanstan muaf (routes/tenant.php), onlar açık kalır.
  get islemKisitli(): boolean {
    return this.$helper.lisansIslemKisitli("kullanici-izinleri");
  }
}
